module.exports = __webpack_public_path__ + "img/pigeon_logo.6c2d1af1.svg";